import React, {useState, useEffect} from 'react';

const Contact = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0); // scrolls to top when component mounts
  }, []);
  
  let green = '2px solid green';
  let red = '2px solid red';
  
  const [nameInputError, setNameInputError] = useState(null);
  const [nameInputBorder, setNameInputBorder] = useState('none');
  const [nameInputValue, setNameInputValue] = useState('');
  
  const [emailInputError, setEmailInputError] = useState(null);
  const [emailFormatError, setEmailFormatError] = useState(null);
  const [emailInputBorder, setEmailInputBorder] = useState('none');
  const [emailInputValue, setEmailInputValue] = useState('');
  
  const [messageInputError, setMessageInputError] = useState(null);
  const [messageInputBorder, setMessageInputBorder] = useState('none');
  const [messageInputValue, setMessageInputValue] = useState('');
  
  const [invalidInput, setInvalidInput] = useState(true);
  
  toggleSubmit();
  
  function activeInput(e) {
    let inputValue = e.target.value;
    let inputField = e.target.id;
    
    switch (inputField) {
      case 'name':
        setNameInputBorder(green);
        setNameInputValue(inputValue);
        break;
      case 'email':
        setEmailInputBorder(green);
        setEmailInputValue(inputValue);
        break;
      case 'message':
        setMessageInputBorder(green);
        setMessageInputValue(inputValue);
        break;
    }
  }
  
  function checkInput(e){
    let inputValue = e.target.value;
    let inputField = e.target.id;
    
    if (inputValue == ''){
      switch (inputField){
      case 'name':
        setNameInputError(true);
        setNameInputBorder(red);
        setNameInputValue(inputValue);
        break;
      case 'email':
        setEmailInputError(true);
        setEmailFormatError(false)
        setEmailInputBorder(red);
        setEmailInputValue(inputValue);
        break;
      case 'message':
        setMessageInputError(true);
        setMessageInputBorder(red);
        setMessageInputValue(inputValue);
        break;
      }
    }
    else{
      switch (inputField){
        case 'name':
          setNameInputError(false);
          setNameInputBorder('none');
          setNameInputValue(inputValue);
          break;
        case 'email':
          let validFormat = new RegExp(".+[@].+[.][a-z]{2,5}$");
          let exception1 = new RegExp("^[.]");
          let exception2 = new RegExp("[.][.]");
          let exception3 = new RegExp("[.][@]");
          let exception4 = new RegExp("[@][.]");
          let exception5 = new RegExp("[@][@]");
          
          if (inputValue.match(validFormat)){
            if(inputValue.match(exception1)||inputValue.match(exception2)||inputValue.match(exception3)||inputValue.match(exception4)||inputValue.match(exception5)){
              setEmailFormatError(true);
              setEmailInputBorder(red);
            }
            else{
              setEmailInputError(false);
              setEmailFormatError(false);
              setEmailInputBorder('none');
            }
          }
          else{
            setEmailFormatError(true);
            setEmailInputBorder(red);
          }
          setEmailInputValue(inputValue);
          break;
        case 'message':
          setMessageInputError(false);
          setMessageInputBorder('none');
          setMessageInputValue(inputValue);
          break;
      }
    }
  }
  
  function toggleSubmit(e){
    
      if(invalidInput){
        if(nameInputValue != '' && emailInputValue != '' && messageInputValue != ''){
          if(!emailFormatError){
            setInvalidInput(false);
          }
        }
      }
      else{
        if(nameInputError || emailInputError || emailFormatError || messageInputError){
          setInvalidInput(true);
        }
      }
  }
  
  const handleKeyDown = (e) => {
    if(e.key === "Enter"){
      e.preventDefault();
      e.target.blur();
    }
  }
  
  return (
    <>
    <main>
    <section id="get-in-touch">
      <h2>Get in Touch</h2>
      
      <div>
        <p className="body2 opacity80">
          I’d love to hear about what you’re working on and how I could help. I’m currently 
          looking for a new role and am open to a wide range of opportunities. My preference 
          would be to find a position in a company in Houston. But I’m also happy to hear about 
          opportunites that don’t fit that description. I’m a hard-working and positive person 
          who will always approach each task with a sense of purpose and attention to detail. 
          Please do feel free to check out my online profiles below and get in touch using the form.
        </p>
      
        <div>
          <img src="images/icons/github.png"/>
          <img src="images/icons/twitter.png"/>
          <img src="images/icons/linkedin.png"/>
        </div>
      </div>
    </section>
    
    <section id="contact-me">
      <h2>Contact Me</h2>
      
      <div>
      <form id="contactme-form" name="portfolio-contact" data-netlify="true" method="POST" action="success.html"/*onKeyDown={handleKeyDown}*/>
        <input type="hidden" name="form-name" value="portfolio-contact"></input>
        <label htmlFor="name" className="opacity80">Name</label>
        <div>
          <input id="name" className="normalinp" type="text" name="name" placeholder="Jane Appleseed" style={{border: nameInputBorder}} onFocus={activeInput} onBlur={checkInput}/>
          <ErrorMsg style={{display: nameInputError ? '' : 'none', color: 'red', fontWeight: 'bold', fontStyle: 'italic', fontFamily: 'Public Sans'}} />
        </div>
        <label htmlFor="email" className="opacity80">Email Address</label>
        <div>
          <input id="email" className="normalinp" type="email" name="email" placeholder="email@example.com" style={{border: emailInputBorder}} onFocus={activeInput} onBlur={checkInput}/>
          {emailFormatError ? <InvalidEmail style={{color: 'red', fontWeight: 'bold', fontStyle: 'italic', fontFamily: 'Public Sans'}} /> : <ErrorMsg style={{display: emailInputError ? '' : 'none', color: 'red', fontWeight: 'bold', fontStyle: 'italic', fontFamily: 'Public Sans'}} />}
        </div>
        <label htmlFor="message" className="opacity80">Message</label>
        <div>
          <textarea id="message" className="normalinp" name="message" placeholder="How can I help?" style={{border: messageInputBorder}} onFocus={activeInput} onBlur={checkInput}></textarea>
          <ErrorMsg style={{display: messageInputError ? '' : 'none', color: 'red', fontWeight: 'bold', fontStyle: 'italic', fontFamily: 'Public Sans'}} />
        </div>
        <button type="submit" className="btn-pnormal" disabled={invalidInput} >SEND MESSAGE</button>
      </form>
      </div>
    </section>
  </main>
    </>
  );
}

export default Contact;

const ErrorMsg = ({style}) => {
  return(
    <p style={style}>This field is required</p>
  );
}

const InvalidEmail = ({style}) => {
  return(
    <p style={style}>Invalid email</p>
  );
}